import { _ as _defineProperty } from './defineProperty-18999f8e.js';
import createUseStyles from './create/index.js';
import { canHover, mediaQuery } from './helpers/index.js';
import { Transitions, OldBreakPoints } from './enums/index.js';
import { FontSizes, FontWeights } from './fonts/index.js';

var _primary;
var useStyles = createUseStyles({
  root: {
    display: 'inline-block',
    alignItems: 'center',
    boxSizing: 'border-box',
    justifyContent: 'center',
    padding: '12px 6px',
    fontSize: 14,
    lineHeight: '19px',
    borderRadius: 8,
    textAlign: 'center',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: "all ".concat(Transitions.Default, " ease-in-out")
  },
  primary: (_primary = {
    border: '1px solid var(--accents-primary-base)',
    backgroundColor: 'var(--accents-primary-base)',
    color: 'var(--accents-primary-text)'
  }, _defineProperty(_primary, canHover(), {
    '&:hover': {
      border: '1px solid var(--accents-primary-base-action)',
      backgroundColor: 'var(--accents-primary-base-action)'
    }
  }), _defineProperty(_primary, canHover(false), {
    '&:active': {
      border: '1px solid var(--accents-primary-base-action)',
      backgroundColor: 'var(--accents-primary-base-action)'
    }
  }), _primary),
  secondary: {
    border: '1px solid #4d4d4f',
    backgroundColor: 'transparent',
    color: '#222222'
  },
  responsive: _defineProperty({
    padding: '19px 40px',
    fontWeight: FontWeights.Medium,
    fontSize: FontSizes.Size_8,
    lineHeight: '28px'
  }, mediaQuery(OldBreakPoints.xlsmall), {
    padding: '12px 6px',
    fontSize: FontSizes.Size_5,
    lineHeight: '19px'
  })
}, {
  name: 'pa-uiLib-button'
});

export { useStyles as u };
//# sourceMappingURL=styles-17912d90.js.map
